import { makeStyle } from '../../../../../utils';
import { columnCenter, subTitle1, black, bold, caption, secondary, h6, rowCenter, subTitle2 } from '../../../../../resources/styles';

const styles = {};

styles['container'] = makeStyle([columnCenter, { alignItems: 'stretch' }]);

styles['ota_heading'] = makeStyle([subTitle1, black, bold, { margin: '0 12px' }]);

styles['field'] = makeStyle({ margin: '32px 12px 0', alignSelf: 'stretch', minWidth: 300 });

styles['adornment'] = makeStyle([caption, secondary, { letterSpacing: '0.2px', cursor: 'pointer', whiteSpace: 'nowrap', marginLeft: 12 }]);
styles['adornment_icon'] = makeStyle([secondary, { cursor: 'pointer' }]);

export default styles;